import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Electricmeter } from './electricmeter.model';
import { ElectricmeterService } from './electricmeter.service';

@Component({
    selector: 'jhi-electricmeter-detail',
    templateUrl: './electricmeter-detail.component.html'
})
export class ElectricmeterDetailComponent implements OnInit, OnDestroy {

    electricmeter: Electricmeter;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private electricmeterService: ElectricmeterService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['electricmeter']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInElectricmeters();
    }

    load(id) {
        this.electricmeterService.find(id).subscribe((electricmeter) => {
            this.electricmeter = electricmeter;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInElectricmeters() {
        this.eventSubscriber = this.eventManager.subscribe('electricmeterListModification', (response) => this.load(this.electricmeter.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/electricmeter/electricmeter-detail.component.ts